import React, { useState, useEffect } from "react";
import Call from "../../assets/img/Call.svg"
import Lock from "../../assets/img/Lock.svg"
import InactiveLock from "../../assets/img/InactiveLock.svg"
import SimDeactivation from "../../assets/img/SimDeactivationBlue.svg"
import InactiveSimDeactivation from "../../assets/img/SimDeactivationInactive.svg"
import Payments from "../../assets/img/PaymentsStepIcon.svg"
import InactivePayments from "../../assets/img/PaymentsStepInactive.svg"
import Translation from "../../services/translation.service"
import Storage from "../../services/storage.service"
import StepperStep from "./stepper-step";

let subscriptions = []
const SimDeactivationStepper = () => {
    const [info, setInfo] = useState({
        step1: {
          status: "inProgress",
        },
        step2: {
          status: "notVisited",
        },
        step3: {
          status: "notVisited",
        }
    });
    const [isPostPaidFlow, setIsPostPaidFlow] = useState(false);

    useEffect(() => {
        subscriptions.push(
            Storage.get_obsrv("act_step_detail").subscribe(data => {
                if (data) {
                    setInfo(data);
                } 
            })
        );

        subscriptions.push(
            Storage.get_obsrv("postpaid_sim_deactivation").subscribe(() => {
                const flowType = Storage.get("postpaid_sim_deactivation", true);
                if(JSON.parse(flowType)) {
                    setIsPostPaidFlow(JSON.parse(true));        
                } else {
                    setIsPostPaidFlow(JSON.parse(false));     
                }
            })
        );


        return () => {
            if (subscriptions && subscriptions?.length) {
                for (let subscription of subscriptions) {
                    subscription.unsubscribe();
                }
            }
        };
    }, []);

    return (<div className="protection_channel_progress_container">
        {/* Number Step */}
        <StepperStep
            title={Translation.keys["stm_sim_deactivation_step1_title"] || "Your number"}
            desc={Translation.keys["stm_sim_deactivation_step1_desc"] || "Start by entering your number"}
            step="1"
            status={info?.step1?.status}
            activeIcon={Call}
            nonActive={Call}
        />
        <div className="divider"></div>

        {isPostPaidFlow ?
        <>
            {/* OTP Step */}
            <StepperStep
                title={Translation.keys["stm_sim_deactivation_step2_title"] || "OTP Verification"}
                desc={Translation.keys["stm_sim_deactivation_step2_desc"] || "Validated"}
                step={"2"}
                status={info?.step2?.status}
                activeIcon={Lock}
                nonActive={InactiveLock}
            />
            <div className="divider"></div>
        </> : ""}

        {!isPostPaidFlow ?
        <>
            {/* Absher Step */}
            <StepperStep
                title={Translation.keys["stm_sim_deactivation_step3_title"] || "Absher"}
                desc={Translation.keys["stm_sim_deactivation_step3_desc"] || "Validated"}
                step={isPostPaidFlow ? "2" : "2"}
                status={info?.step3?.status}
                activeIcon={Lock}
                nonActive={InactiveLock}
            />
            <div className="divider"></div>
        </> : ""}

        {isPostPaidFlow ?
        <>
            {/* Pay Bills Step */}
            <StepperStep
                title={Translation.keys["stm_sim_deactivation_step4_title"] || "Pay bill"}
                desc={Translation.keys["stm_sim_deactivation_step4_desc"] || "Pay remaining bills before deactivation"}
                step={isPostPaidFlow ? "3" : ""}
                status={info?.step4?.status}
                activeIcon={Payments}
                nonActive={InactivePayments}
            />
            <div className="divider"></div>
        </> : ""}

        <>
            {/* Confirmation Step */}
            <StepperStep
                title={Translation.keys["stm_sim_deactivation_step5_title"] || "Confirmation"}
                desc={Translation.keys["stm_sim_deactivation_step5_desc"] || "That's it! Your SIM is deactivated"}
                step={isPostPaidFlow ? "4" : "3"}
                status={info?.step5?.status}
                activeIcon={SimDeactivation}
                nonActive={InactiveSimDeactivation}
            />
        </>
    </div>)
}

export default SimDeactivationStepper